import { ExtendedButtonProps } from "@components/general/Button/Button";
import { forwardRef } from "react";
import { NavigationDropdownToggle } from "@components/general/NavigationDropdownToggle/NavigationDropdownToggle";
import { useElipsis } from "@hooks/useElipsis";

const MAX_TOGGLE_TEXT_LENGTH = 13;

interface NavigationToggleBaseProps extends ExtendedButtonProps {
    text: string;
}

export const NavigationToggleBase = forwardRef(
    ({ onClick, text }: NavigationToggleBaseProps, ref) => {
        const shortName = useElipsis(text, MAX_TOGGLE_TEXT_LENGTH);

        return (
            <NavigationDropdownToggle onClick={onClick} ref={ref as any}>
                {shortName}
            </NavigationDropdownToggle>
        );
    },
);
